export default __webpack_public_path__ + "static/media/epm.97894a6c.png";